<template>
	<div class="form-group" :class="{ 'form-group--error' : validate.month.$error || validate.day.$error || validate.year.$error }">
		<fieldset class="fieldset" :aria-describedby="hintId" role="group">
			<legend class="fieldset__legend fieldset__legend--xs">    
				<h2>What is the young person's date of birth?</h2>    
			</legend>
			<span :id="hintId" class="hint">For example, 31 01 2010</span>		
			<div v-if="detailsTitle" class="push__top">
				<Details :id="detailsId" :title="detailsTitle" :message="detailsMessage"/>
			</div>

			<span class="error-message" v-if="validate.checkDate == false && validate.$error && validate.day.required == true && validate.month.required == true && validate.year.required == true">This is not a valid date</span>	
			<span class="error-message" v-if="validate.day.required == false && validate.$error">Day is a required field</span>	
			<span class="error-message" v-if="validate.month.required == false && validate.$error">Month is a required field</span>	
			<span class="error-message" v-if="validate.year.required == false && validate.$error">Year is a required field</span>			
			<span class="error-message" v-if="validate.day.maxValue == false && validate.$error || validate.day.minValue == false && validate.$error">Day field must be within 1 - 31</span>
			<span class="error-message" v-if="validate.month.maxValue == false && validate.$error || validate.month.minValue == false && validate.$error">Month field must be within 1 - 12</span>
			<span class="error-message" v-if="validate.year.maxValue == false && validate.$error || validate.year.minValue == false &&validate.$error">Year field must be within 1900 - {{currentYear}}</span>
			<div class="date" id="date-ex-1">
				<slot></slot>
			</div>
		</fieldset>   
	</div>
</template>

<script>
export default {
	name: 'Fieldset',
	props: {
		id: String,
		errorMessage: String,
		detailsTitle: String,
		detailsMessage: String,
		validate: {
			type: Object,
			required: false
		},
	},
  computed: {
    detailsId() {
      return `${this.id}-details`;
    },
	},
	data() {
		return {
			hintId : this.id + '-hint',
			currentYear : new Date().getFullYear()
		}
	},
	methods: {
		submit() {
			this.$emit("submit");
		}
	}
}
</script>